import { memo, useMemo } from "react";

import BadgeNext from "ds/components/BadgeNext";
import { ArrowsLeftRight } from "components/icons/generated";

import { type RenderResourceRowCellProps } from ".";
import IacManagementEmptyCellValue from "../../components/CellEmptyValue";
import useCellFilterAction from "../useCellFilterAction";
import { ResourcesSuggestions } from "../../useIacManagementFilters/constants";
import IacManagementResourceCell from "../components/ResourceCell";

const IacManagementTableResourceRowCellDrifted = memo((props: RenderResourceRowCellProps) => {
  const { row } = props;

  const driftedFilterAction = useCellFilterAction(
    ResourcesSuggestions.Drifted,
    (!!row.drifted).toString()
  );
  const actions = useMemo(() => [driftedFilterAction], [driftedFilterAction]);

  return (
    <IacManagementResourceCell {...props} actions={actions}>
      {(row.drifted && (
        <BadgeNext type="weak" variant="yellow" startIcon={ArrowsLeftRight} iconOnly />
      )) || <IacManagementEmptyCellValue />}
    </IacManagementResourceCell>
  );
});

IacManagementTableResourceRowCellDrifted.displayName = "IacManagementTableResourceRowCellDrifted";

export default IacManagementTableResourceRowCellDrifted;
